module.exports = __webpack_public_path__ + "static/img/media_01.1daad7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/media_01.png
// module id = tgrI
// module chunks = 0